/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ExchangeCancelCategory } from './exchange-cancel-category';

/**
 * 
 * @export
 * @interface GetExchangeDataDto
 */
export interface GetExchangeDataDto {
    /**
     * 환급 uuid
     * @type {string}
     * @memberof GetExchangeDataDto
     */
    'exchangeUuid': string;
    /**
     * 환급 신청 금액
     * @type {number}
     * @memberof GetExchangeDataDto
     */
    'amountRequested': number;
    /**
     * 환급 상태
     * @type {string}
     * @memberof GetExchangeDataDto
     */
    'status': GetExchangeDataDtoStatusEnum;
    /**
     * 생성 일시
     * @type {string}
     * @memberof GetExchangeDataDto
     */
    'createdAt': string;
    /**
     * 기타 환급 불가 사유
     * @type {string}
     * @memberof GetExchangeDataDto
     */
    'exchangeCancelOtherReason': string;
    /**
     * 환급 (예정) 일시
     * @type {string}
     * @memberof GetExchangeDataDto
     */
    'exchangeAt': string;
    /**
     * 취소 여부
     * @type {boolean}
     * @memberof GetExchangeDataDto
     */
    'isCancelled': boolean;
    /**
     * 환급 불가 사유
     * @type {ExchangeCancelCategory}
     * @memberof GetExchangeDataDto
     */
    'exchangeCancelCategory': ExchangeCancelCategory;
}

export const GetExchangeDataDtoStatusEnum = {
    Application: 'application',
    Waiting: 'waiting',
    Completed: 'completed',
    Impossible: 'impossible'
} as const;

export type GetExchangeDataDtoStatusEnum = typeof GetExchangeDataDtoStatusEnum[keyof typeof GetExchangeDataDtoStatusEnum];


